"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TaskSorter = require("./TaskSorter");

var _TaskSorter2 = _interopRequireDefault(_TaskSorter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TaskSorter2.default;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-task-sorter@0.0.21@@alicd/crui-task-sorter/lib/index.js
// module id = 722
// module chunks = 0